import type { DeliveryTabGridEntry } from "@/lib/api/dispatchTypes";
import { useOffPremiseBills } from "@/modules/pos/components/OffPremiseFloor";
import { isDispatchableBill } from "./dispatchBoard";
import { deliveryTabBadge, offPremiseTabAvailable, waitingRows } from "./deliveryWaiting";
import { useDispatchAccess, useDispatchBoard } from "./useDispatchBoard";

/**
 * The Delivery tab over the PAPER register (B6 · P24b): whether the session
 * gets it (`offPremiseTabAvailable`: may close a bill ∥ the board, the floor's own rule) and the same count and
 * tone the floor's tab shows — the same reads (`useOffPremiseBills`, the
 * board) under the same query keys, so the two tabs never disagree.
 */
export function useDeliveryTabBadge({
  enabled,
  canClose,
}: {
  enabled: boolean;
  /** `INVOICE_CLOSE` — the till's money line, not a waiter's. */
  canClose: boolean;
}): { available: boolean; count: number; tone: "alert" | "info" } {
  const access = useDispatchAccess();
  const available = enabled && offPremiseTabAvailable({ canClose, canSeeBoard: access.canSeeBoard });
  const { bills } = useOffPremiseBills({ enabled: available });
  const delivery = bills as DeliveryTabGridEntry[];
  const dispatch = useDispatchBoard({ enabled: available && delivery.some(isDispatchableBill) });
  const rows =
    access.canSeeBoard && dispatch.board ? waitingRows(delivery, dispatch.lookup, dispatch.now) : [];
  return { available, ...deliveryTabBadge(delivery, access.canSeeBoard, rows) };
}
